// Context que expone los productos reales del usuario a todos los
// componentes de Interfaz V2 que los necesitan (pickers, chips de
// resumen, tool cards del chat, etc.). Antes los componentes leían
// `MOCK_USER_PRODUCTS` directo del módulo — esto los conecta a la data
// real fetchada por `fetchUserProducts(companyId)`.
//
// Default = array vacío. Si todavía no se cargaron, los pickers muestran
// estado vacío (no rompe nada).

import { createContext, useContext } from 'react';
import type { MockProductV2 } from './mockData';

export const ProductsContext = createContext<MockProductV2[]>([]);

export const useUserProducts = (): MockProductV2[] => useContext(ProductsContext);

// Flag: ya terminó el PRIMER fetch de productos. Mientras es `false`, la UI
// no sabe si el user tiene productos o no — sirve para mostrar el CTA
// "Elegir de mis productos" de forma OPTIMISTA durante la carga (en vez de
// esconderlo hasta que `fetchUserProducts` resuelva, lo que dejaba el botón
// apareciendo "tarde" al abrir un modo), y ocultarlo solo si tras cargar
// confirmamos que el catálogo está vacío.
export const ProductsLoadedContext = createContext<boolean>(false);

export const useUserProductsLoaded = (): boolean =>
  useContext(ProductsLoadedContext);

// Context de edición de productos: expone lo que un picker necesita para abrir
// la modal "Editar producto" (EditProductFlow) sin pasar props por todos los
// call-sites — el `companyId` del user y un `refreshProducts` que re-fetchea el
// catálogo tras renombrar / borrar / cambiar imágenes. Lo provee InterfazV2.
export interface ProductEditContextValue {
  companyId: string | null;
  refreshProducts: () => Promise<void> | void;
}

export const ProductEditContext = createContext<ProductEditContextValue>({
  companyId: null,
  refreshProducts: () => {},
});

export const useProductEdit = (): ProductEditContextValue =>
  useContext(ProductEditContext);
